import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useAPI, useMe } from 'global'
import { Role } from 'enums'
import { TextField, Button, SearchableSelect } from 'components'
import KeySection from './keySection'
import './styles.scss'

export default function StoreEditScreen(props) {
  const { storeData = {}, onSubmit, onCancel, organization: org } = props
  const { store, address, region } = storeData

  const { t } = useTranslation(null, { useSuspense: false })
  const { me } = useMe()
  const api = useAPI()

  const name = useRef()
  const branchCode = useRef()
  const timeZoneSelect = useRef()
  const regionSelect = useRef()

  const contactName = useRef()
  const contactEmail = useRef()
  const contactPhone = useRef()

  const keySettings = useRef()

  const address1 = useRef()
  const address2 = useRef()
  const address3 = useRef()
  const city = useRef()
  const state = useRef()
  const country = useRef()
  const postalCode = useRef()

  const submit = e => {
    e.preventDefault()
    const storePayload = {
      name: name.current.value?.trim(),
      branchCode: branchCode.current.value?.trim() || null,
      timeZone: timeZoneSelect.current.value,
      regionId: regionSelect.current?.value?.id || null,
      contactName: contactName.current.value?.trim(),
      contactEmail: contactEmail.current.value?.trim(),
      contactPhone: contactPhone.current.value?.trim(),
      allowedKeyTypes: keySettings.current.allowedKeyTypes,
      keyExpTimeIntervalEnabled: keySettings.current.expirationEnabled,
      keyExpTimeInterval: keySettings.current.expirationInterval,
      address: {
        address1: address1.current.value?.trim(),
        address2: address2.current.value?.trim(),
        address3: address3.current.value?.trim(),
        city: city.current.value?.trim(),
        state: state.current.value?.trim(),
        zip: postalCode.current.value?.trim(),
        country: country.current.value?.trim(),
      },
    }
    if (store?.id) storePayload.id = store?.id
    onSubmit(storePayload)
  }

  const searchRegions = (searchText, pageNumber) => {
    const query = {
      name: searchText,
      page: pageNumber || 1,
    }
    api.getRegions(query).then(response => {
      regionSelect.current.addData(response?.regions, response?.meta)
    }).catch(() => { })
  }

  return (
    <div className='store-edit-comp'>
      <form className='col' onSubmit={submit}>
        <div className='section col'>
          <p className='subheading'>{t('storeDetails.general')}</p>
          <TextField required label={t('storeDetails.name')} ref={name} defaultValue={store?.name} />
          <TextField required={org?.requireBranchCode} label={t('storeEdit.branchCode')} ref={branchCode} defaultValue={store?.branchCode} />
          <SearchableSelect
            ref={timeZoneSelect}
            staticData={Intl.supportedValuesOf('timeZone')}
            defaultValue={store?.timeZone}
            label={t('storeDetails.timeZone')}
            required
          />
          <SearchableSelect
            required={me?.roleKey === Role.regionalManager}
            ref={regionSelect}
            onSearch={searchRegions}
            defaultValue={region}
            label={t('storeDetails.region')}
          />
        </div>
        <div className='section col'>
          <p className='subheading'>{t('storeDetails.contact')}</p>
          <TextField required label={t('storeDetails.contactName')} ref={contactName} defaultValue={store?.contactName} />
          <TextField required label={t('storeDetails.contactEmail')} ref={contactEmail} defaultValue={store?.contactEmail} type='email' />
          <TextField label={t('storeDetails.contactPhone')} ref={contactPhone} defaultValue={store?.contactPhone} />
        </div>

        <KeySection ref={keySettings} store={store} org={org} />

        <div className='section col'>
          <p className='subheading'>{t('address.address')}</p>
          <TextField required label={t('address.address1')} ref={address1} defaultValue={address?.address1} />
          <TextField label={t('address.address2')} ref={address2} defaultValue={address?.address2} />
          <TextField label={t('address.address3')} ref={address3} defaultValue={address?.address3} />
          <TextField required label={t('address.city')} ref={city} defaultValue={address?.city}/>
          <TextField label={t('address.state')} ref={state} defaultValue={address?.state} />
          <TextField required label={t('address.postalCode')} ref={postalCode} defaultValue={address?.zip} />
          <TextField required label={t('address.country')} ref={country} defaultValue={address?.country}/>
        </div>

        <div className='row button-row'>
          <Button outline onClick={onCancel}>{t('form.cancel')}</Button>
          <Button type='submit'>{t('form.save')}</Button>
        </div>
      </form>
    </div>
  )
}
